
import React from 'react';
export const Stop = props => (
  <svg viewBox="0 0 20 20" {...props}><path d="M10,0 C4.47767857,0 0,4.47767857 0,10 C0,15.5223214 4.47767857,20 10,20 C15.5223214,20 20,15.5223214 20,10 C20,4.47767857 15.5223214,0 10,0 Z M15.2410714,16.4397321 L3.56026786,4.75892857 C3.91741071,4.31919643 4.31919643,3.91741071 4.75892857,3.56026786 L16.4397321,15.2410714 C16.0825893,15.6785714 15.6808036,16.0825893 15.2410714,16.4397321 Z" fillRule="evenodd" /></svg>
);
